"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versions = void 0;
;
exports.versions = {
  version: '3.0.10',
  name: 'lingo2-api-models',
  versionDate: '2025-06-03T08:28:14.005Z',
  description: 'Shared api models library',
  gitCommitHash: 'g2e08e19',
  gitCommitDate: '2025-06-03T08:27:41.000Z',
  versionLong: '3.0.10-g2e08e19',
  gitTag: 'v3.0.9'
};
exports.default = exports.versions;
